import { AiFlags } from 'ContentEditorUI/types/AiFlag';
//@ts-expect-error still in TS
import { updateAiFeatures } from 'ContentEditorUI/redux/actions/baseContentModelActions';
import { getAiFeaturesAsRecord } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getCanUpdateAiFlags } from 'EmailEditorUI/redux/selectors/AiSelectors';
import { getImageModules } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
export const updateAiFeaturesForSubjectLine = ({
  subjectLine,
  smartSubjectLines,
  allGeneratedSubjectLines
}) => (dispatch, getState) => {
  const state = getState();
  const canUpdateAiFlags = getCanUpdateAiFlags(state);
  if (canUpdateAiFlags) {
    const aiFeatures = getAiFeaturesAsRecord(state);
    const allCurrentSubjectLines = [subjectLine, ...smartSubjectLines];
    const isGeneratedBefore = s => allGeneratedSubjectLines.includes(s);
    const allSubjectLinesAreGeneratedOrEmpty = allCurrentSubjectLines.map(subject => isGeneratedBefore(subject) || subject === '').every(Boolean);
    const hasAtleastOneValue = allCurrentSubjectLines.some(Boolean);
    const generatedByAi = allSubjectLinesAreGeneratedOrEmpty && hasAtleastOneValue;
    const currentFlag = aiFeatures[AiFlags.SUBJECT_LINE];
    const currentFlagIsByAi = currentFlag === 'generatedByAi';
    const flagType = (() => {
      if (generatedByAi) {
        return 'generatedByAi';
      }
      if (currentFlagIsByAi) {
        return 'generatedWithAi';
      }
      return currentFlag;
    })();
    dispatch(updateAiFeatures({
      flags: [AiFlags.SUBJECT_LINE],
      flagType
    }));
  }
};
export const updateAiFeaturesForPreviewText = ({
  previewText,
  allGeneratedPreviewTexts
}) => (dispatch, getState) => {
  const state = getState();
  const canUpdateAiFlags = getCanUpdateAiFlags(state);
  if (canUpdateAiFlags) {
    const aiFeatures = getAiFeaturesAsRecord(state);
    const isGeneratedBefore = s => allGeneratedPreviewTexts.includes(s);
    const generatedByAi = isGeneratedBefore(previewText);
    const currentFlag = aiFeatures[AiFlags.PREVIEW_TEXT];
    const currentFlagIsByAi = currentFlag === 'generatedByAi';
    const flagType = (() => {
      if (generatedByAi) {
        return 'generatedByAi';
      }
      if (currentFlagIsByAi) {
        return 'generatedWithAi';
      }
      return currentFlag;
    })();
    dispatch(updateAiFeatures({
      flags: [AiFlags.PREVIEW_TEXT],
      flagType
    }));
  }
};
export const updateAiFeaturesForImageSelect = ({
  fileManagerResult
}) => (dispatch, getState) => {
  const state = getState();
  const canUpdateAiFlags = getCanUpdateAiFlags(state);
  if (canUpdateAiFlags) {
    const aiFeatures = getAiFeaturesAsRecord(state);
    const imageModules = getImageModules(state);
    const onlyOneImage = imageModules.length === 1;
    const generatedByAi = Boolean('meta' in fileManagerResult && 'ai_generated' in fileManagerResult.meta && fileManagerResult.meta.ai_generated);
    const currentFlag = aiFeatures[AiFlags.IMAGE];
    const currentFlagIsByAi = currentFlag === 'generatedByAi';
    const flagType = (() => {
      if (onlyOneImage && generatedByAi) {
        return 'generatedByAi';
      }
      if (onlyOneImage && !generatedByAi) {
        return null;
      }
      if (currentFlagIsByAi && !generatedByAi) {
        return 'generatedWithAi';
      }
      if (!currentFlag && generatedByAi) {
        return 'generatedWithAi';
      }
      return currentFlag;
    })();
    dispatch(updateAiFeatures({
      flags: [AiFlags.IMAGE],
      flagType
    }));
  }
};
export const updateAiFeaturesForRemoveElements = ({
  elementIds
}) => (dispatch, getState) => {
  const state = getState();
  const canUpdateAiFlags = getCanUpdateAiFlags(state);
  if (canUpdateAiFlags) {
    const aiFeatures = getAiFeaturesAsRecord(state);
    const imageModules = getImageModules(state);
    const imageModulesBeingDeleted = imageModules.filter(imageModule => {
      return elementIds.includes(imageModule);
    });
    const deletingAllImageModules = imageModules.length === imageModulesBeingDeleted.length;
    const currentFlag = aiFeatures[AiFlags.IMAGE];
    const flagType = (() => {
      if (deletingAllImageModules) {
        return null;
      }
      return currentFlag;
    })();
    dispatch(updateAiFeatures({
      flags: [AiFlags.IMAGE],
      flagType
    }));
  }
};
export const updateAiFeaturesForMainContent = () => (dispatch, getState) => {
  const state = getState();
  const canUpdateAiFlags = getCanUpdateAiFlags(state);
  if (canUpdateAiFlags) {
    dispatch(updateAiFeatures({
      flags: [AiFlags.MAIN_CONTENT],
      flagType: 'generatedWithAi'
    }));
  }
};